import {
  CalendarOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  MinusOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import type { IClientInsuranceStatusConfig, TClientInsuranceStatusKey } from './types';

export const CLIENT_INSURANCE_STATUS_MAP: Record<TClientInsuranceStatusKey, IClientInsuranceStatusConfig> = {
  no_insurance: {
    backgroundColor: 'var(--gray-3)',
    icon: MinusOutlined,
    text: 'No insurance',
    textColor: 'var(--gray-7)',
  },
  active: {
    backgroundColor: 'var(--green-1)',
    icon: CheckCircleOutlined,
    text: 'Active',
    textColor: 'var(--green-6)',
  },
  expiring_soon: {
    backgroundColor: 'var(--warning-bg)',
    icon: ClockCircleOutlined,
    text: 'Expiring soon',
    textColor: 'var(--warning-text)',
  },
  expiring_soon_next_ready: {
    backgroundColor: 'var(--green-1)',
    icon: CheckCircleOutlined,
    text: 'Renewal ready',
    textColor: 'var(--green-6)',
  },
  expiring_soon_gap_before_next: {
    backgroundColor: 'var(--warning-bg)',
    icon: ExclamationCircleOutlined,
    text: 'Gap before next',
    textColor: 'var(--warning-text)',
  },
  expired: {
    backgroundColor: 'var(--red-2)',
    icon: WarningOutlined,
    text: 'Expired',
    textColor: 'var(--red-7)',
  },
  upcoming: {
    backgroundColor: 'var(--gray-3)',
    icon: CalendarOutlined,
    text: 'Upcoming',
    textColor: 'var(--gray-7)',
  },
};
